import { createElement } from "@wordpress/element";
import { PropTypes } from "prop-types";
import classNames from "classnames";
import { forwardRef } from "@wordpress/element";
const Page = forwardRef(({
  as: Component = "div",
  children,
  className = "",
  ...props
}, ref) => createElement(Component, {
  ...props,
  className: classNames("nfd-page", className),
  ref: ref
}, children));
Page.propTypes = {
  as: PropTypes.element,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
export default Page;